import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Antd from "ant-design-vue";
import api from "./api/api";
import moment from "moment";
import "ant-design-vue/dist/antd.css";
import wx from "weixin-jsapi";

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";

import "babel-polyfill";
import BaiduMap from "vue-baidu-map";

Vue.config.productionTip = false;

Vue.use(Antd);

Vue.use(preview);

Vue.use(BaiduMap, { ak: "9F7n6bjK0zW9jW0dSnnzxjnD1AlN1o3G" });

Vue.prototype.api = api;

Vue.prototype.state = store.state;

Vue.prototype.qiniuURL = "http://qiniu.0550.com/";

Vue.prototype.wx = wx;
Vue.filter("datetime", function(value, format = "YYYY-MM-DD HH:mm:ss") {
  return moment(value).format(format);
});

Vue.filter("date", function(value, format = "YYYY-MM-DD") {
  return moment(value).format(format);
});

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    let title = "";
    for (let i = 0; i < to.meta.title.length; i++) {
      title += to.meta.title[i] + " ";
    }
    document.title = title;
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
